
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/historique-enneigement",
      function () {
        return require("private-next-pages/[region]/[resort]/historique-enneigement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/historique-enneigement"])
      });
    }
  